export default __webpack_public_path__ + "static/media/OpenClass.d5bb364c.png";